import { MetadataAuthoringRule } from '@adaptiva/metadata/common';
import { IExpressionMetadataAuthoringRule } from '../interfaces';

export class ExpressionMetadataAuthoringRule implements IExpressionMetadataAuthoringRule {

	public type: int;

	public expression: string;

	constructor(_expression?: string) {
		this.type = MetadataAuthoringRule.EXPRESSION;
		if (_expression) {
			this.expression = _expression;
		}
	}
}
